export default "__VITE_ASSET__CtjUjnXH__"